export enum LobbyState {
  inLobby = 0,
  gameInProgress = 1,
  closed = 2,
}

export enum GameRoomType {
  gameRoomInLobby,
  publicGameRoom,
}